export const SET_ASSETS_ACCESS_TOKEN_SUCCESS = 'SET_ASSETS_ACCESS_TOKEN_SUCCESS'
export const SET_ASSETS_ACCESS_TOKEN_FAILED = 'SET_ASSETS_ACCESS_TOKEN_FAILED'

export const ERROR_CODES = {
  MISSING_DEVICE_IDENTITY: 'MISSING_DEVICE_IDENTITY',
  NOT_SUPPORTED_ASSETS_TOKEN: 'NOT_SUPPORTED_ASSETS_TOKEN',
}
